// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1019":"af9ca09e","1817":"efef1649","2320":"d4bee6f5","3672":"c75576e4","3850":"efef1649","4487":"efef1649","6924":"efef1649"}[chunkId] + ".chunk.css";
};